﻿import { useEffect } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";

interface IProps {
  translationId: string;
  isError: boolean;
}

export const useGetError = ({ translationId, isError }: IProps): void => {
  const intl = useIntl();

  useEffect(() => {
    if (!isError) return;

    toast.error(
      intl.formatMessage(
        { id: "general.failedToRetrieveEntity" },
        {
          entity: intl.formatMessage({ id: translationId }),
        }
      )
    );
  }, [translationId, intl, isError]);
};
